"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/Wizard/Message/MissingValuesPrompt.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);



var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _broadcastTemplateTokens = require('shared/services/broadcastTemplateTokens');
var _broadcastTemplate = require('shared/services/broadcastTemplate');

var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _Form = require('web/components/Form');
var _format = require('web/screens/Broadcast/format');
var _noAutofill = require('web/screens/Broadcast/Wizard/Recipients/noAutofill');
var _helpers = require('../helpers');
















/* Rev 34 S4: saving a message that uses a variable some recipients have no
 * value for asks first. Leave them out saves (the launch gate skips them at
 * send); Set a default… gives each declared variable a default, then saves.
 * Rev 35 E4: a built-in name (first_name) takes a fallback instead (Use a
 * fallback…), written into each of its tokens that has none. An undeclared
 * token says to give it a fallback in the message (review R800-73). */
const MissingValuesPrompt = ({ campaignKey, missing, declared, onClose, onSave }) => {
  const isOpen = missing.length > 0
  const [isFilling, setIsFilling] = _react.useState.call(void 0, false)
  const [defaults, setDefaults] = _react.useState({})
  const [isSaving, setIsSaving] = _react.useState.call(void 0, false)
  const [error, setError] = _react.useState(null)
  _react.useEffect.call(void 0, 
    () => {
      if (!isOpen) return
      setIsFilling(false)
      setDefaults({})
      setIsSaving(false)
      setError(null)
    },
    [isOpen],
  )

  const canDefault = (name) => declared.includes(name)
  const variables = missing.filter(m => canDefault(m.Name))
  const names = missing.filter(m => _broadcastTemplate.isBuiltInVariable.call(void 0, m.Name))
  const fillable = [...variables, ...names]
  const value = (name) => (_nullishCoalesce(defaults[name], () => ( ''))).trim()
  const hasBadDefault = variables.some(m => _broadcastTemplateTokens.INVALID_DEFAULT.test(value(m.Name)))
  const hasBadFallback = names.some(m => _broadcastTemplateTokens.INVALID_DEFAULT.test(value(m.Name)))
  const canSave = fillable.every(m => value(m.Name)) && !hasBadDefault && !hasBadFallback && !isSaving
  const fillLabel = !names.length ? 'Set a default…' : variables.length ? 'Set a default or fallback…' : 'Use a fallback…'

  const save = async () => {
    if (!canSave) return
    setIsSaving(true)
    setError(null)
    try {
      for (const m of variables) {
        await _actions2.default.updateCampaignVariable({ CampaignKey: campaignKey, Name: m.Name, NewName: m.Name, Default: value(m.Name) })
      }
      onSave(Object.fromEntries(names.map(m => [m.Name, value(m.Name)])))
    } catch (e) {
      setError(_helpers.errorText.call(void 0, e, "Couldn't save the default"))
      setIsSaving(false)
    }
  }

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: isOpen,
      title: "Some recipients have no value"    ,
      size: "xs",
      onClose: isSaving ? undefined : onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}

      , _react2.default.createElement('ul', { className: "broadcast-missing-prompt--list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}
        ,  missing.map(m => (
          _react2.default.createElement('li', { key: m.Name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}}
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 88}},  _format.pluralize.call(void 0, m.Count, 'recipient has', 'recipients have') , " no "  , _react2.default.createElement('code', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 88}},  `{{${m.Name}}}` ))
            ,  !canDefault(m.Name) && !_broadcastTemplate.isBuiltInVariable.call(void 0, m.Name) && (
              _react2.default.createElement('span', { className: "broadcast-missing-prompt--fallback", __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}, "Give it a fallback in the message, like "
                        , _react2.default.createElement('code', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 91}},  `{{${m.Name} | there}}` )
              )
            )
            ,  isFilling && fillable.includes(m) && (
              _react2.default.createElement('input', {
                // oxlint-disable-next-line jsx-a11y/no-autofocus -- the user just chose to fill them in
                autoFocus: m === missing.find(x => fillable.includes(x)),
                className: "blm-text-input broadcast-missing-prompt--input" ,
                'aria-label': `${_broadcastTemplate.isBuiltInVariable.call(void 0, m.Name) ? 'Fallback' : 'Default'} for ${m.Name}`,
                placeholder: _broadcastTemplate.isBuiltInVariable.call(void 0, m.Name) ? 'Fallback, like there' : 'Default value',
                ..._noAutofill.NO_AUTOFILL,
                value: _nullishCoalesce(defaults[m.Name], () => ( '')),
                onChange: e => setDefaults(d => ({ ...d, [m.Name]: e.target.value })),
                onKeyDown: e => { if (e.key === 'Enter') save().catch(log.error) }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}
              )
            )
          )
        ))
      )
      , _react2.default.createElement('p', { className: "broadcast-missing-prompt--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 110}}
        ,  !isFilling
          ? 'If you leave them out, they stay in the campaign and are skipped when you send.'
          : hasBadDefault ? "A default can't contain { or }"
            : hasBadFallback ? "A fallback can't contain { or }"
              : variables.length ? 'Everyone without their own value gets the default.'
                : 'Everyone with a blank name gets the fallback in the message.' 
      )
      ,  error && _react2.default.createElement('p', { role: "alert", className: "broadcast-wizard--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}},  error ) 
      , _react2.default.createElement('div', { className: "blm-modal--buttons-wrapper broadcast-missing-prompt--foot" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 119}}
        , _react2.default.createElement(_Form.Button, { isSecondary: true, isDisabled: isSaving, onClick: () => onSave(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 120}}, "Leave them out"  )
        ,  fillable.length > 0 && (isFilling
          ? _react2.default.createElement(_Form.Button, { isDisabled: !canSave, isLoading: isSaving, onClick: save, __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}}, "Save")
          : _react2.default.createElement(_Form.Button, { onClick: () => setIsFilling(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 123}},  fillLabel )
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, MissingValuesPrompt)
